/* eslint-disable no-nested-ternary */
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { Image, FadeInAnimation, Button } from '../components/shared';
import MetaData from '../components/shared/meta-data.component';

const errors = {
    404: {
        title: "Whoops! It looks like you're lost.",
        message: "The requested URL was not found on this server. That's all we know.",
        src: '../../assets/images/404.png',
    },
    500: {
        title: 'We have no idea what happened.',
        message:
            'The server encountered an error and could not complete your request. If the problem persists, please contact support and mention this error message and explain what happened before the error occurred.',
        src: '../../assets/images/500.png',
    },
    503: {
        title: "We'll Be Back Soon",
        message:
            'HOMii is down for scheduled maintenance and expect to back online in a few minutes.',
        src: '../../assets/images/503.png',
    },
};

const possibleErrors = [404, 500, 503];

const Error = ({ statusCode: _statusCode }) => {
    
    const statusCode = _.includes(possibleErrors, _statusCode) ? _statusCode : 500;       
    const router = useRouter();
    const onClickGoHome = () => router.push('/');

    const renderError = () => {
        return (
            <div className='error-page-container'>
                <div className='container-root container-root-maxWidthLg'>
                    <div className='main-grid-container'>
                        <div className='main-grid-item main-grid-sm-5 main-grid-xs-12'>
                            <FadeInAnimation>
                                <h6>Error {statusCode}</h6>
                                <h1>{errors[statusCode].title}</h1>
                                <p className='error-paragraph'>{errors[statusCode].message}</p>
                                {statusCode !== 503 && (
                                    <Button onClick={onClickGoHome} id="back-to-homepage-button">Back to Homepage</Button>
                                )}
                            </FadeInAnimation>
                        </div>
                        <div className='main-grid-item main-grid-xs-12'>
                            <FadeInAnimation>
                                <Image
                                    src={errors[statusCode].src}
                                    className={statusCode === 404 ? 'error-page-image-code-404' : 'error-page-image-no-code'}                                    
                                    alt={`${statusCode} Error`}
                                    isOldImage
                                />
                            </FadeInAnimation>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <MetaData title={`Error ${statusCode}`} desc="" />
            {statusCode !== 503}
            {renderError()}
        </>
    );
};

Error.getInitialProps = ({ res, err }) => {
    let statusCode;
    if (res) {
        statusCode = res.statusCode;
    } else if (err) {
        statusCode = err.statusCode;
    } else {
        statusCode = 404;
    }
    if (statusCode >= 400 && statusCode < 500) {
        statusCode = 404;
    } else if (statusCode === 503) {
        statusCode = 503;
    } else {
        statusCode = 500;
    }
    return { statusCode };
};

export default Error;

Error.propTypes = {
    statusCode: PropTypes.number,
};
